export const portfolioData = {
  personal: {
    name: "Vidhi Verma",
    tagline: "Growth Marketer & Content Strategist",
    shortIntro: "I turn ideas into viral content and build communities that actually care.",
    story: "I'm not your typical marketer. I spot trends before they're trends, turn memes into marketing gold, and build communities that feel like home.\n\nWhether it's scripting YouTube videos that hit 83K views or creating Instagram campaigns that stop the scroll, I thrive on making brands feel human. I've worked across startups, large enterprises, and infrastructure companies—giving me a 360-degree view of social media marketing.\n\nI believe in storytelling over selling, relationships over transactions, and data that tells a story worth sharing.",
    email: "vidhi.verma2015@gmail.com",
    phone: "+91 9315569937",
    location: "Bengaluru, India",
    linkedin: "https://www.linkedin.com/in/vidhiverma2002/",
    twitter: "https://x.com/0xvidhi",
    image: "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/6zieuxt5_image.png"
  },
  
  featuredWork: [
        {
      id: 1,
      title: "Community Building & Events at Airtribe",
      subtitle: "40+ Events, 50+ Attendees Each",
      description: "Planned, hosted, and executed 40+ community events - fireside chats, panel discussions, and networking events that drove both community loyalty and revenue.",
      role: "Event Planning, Hosting, Fireside Chat Moderation, Community Management",
      challenge: "Build genuine connections beyond digital interactions and convert events into revenue opportunities.",
      solution: "Designed curated events bringing together learners, mentors, and industry professionals for meaningful networking.",
      impact: [
        "Organized and hosted 40+ successful events",
        "Consistent 50+ attendee turnout per event",
        "Closed multiple sales directly from events"
      ],
      metrics: [
        { value: "40+", label: "Events Organized" },
        { value: "50+", label: "Attendees Per Event" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/cikcfgcn_Screenshot%202026-04-17%20at%202.07.04%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/p/DFpwht5S8bM/",
        "https://www.instagram.com/p/DFnG4o9pWdR/",
        "https://www.instagram.com/p/DFXvlnLosx2/",
        "https://www.instagram.com/p/DD7D4bWJYOj/",
        "https://www.instagram.com/p/DDZecEkyaH7/"
      ],
      tags: ["Community Building", "Event Hosting", "Fireside Chats", "Networking", "Revenue Generation"]
    },,
        {
      id: 2,
      title: "Podcast Production & Hosting",
      subtitle: "20+ Episodes - Crafting Conversations That Matter",
      description: "Produced and shaped 20+ podcast episodes featuring industry leaders. Drafted thought-provoking questions, provided creative direction, and guided conversations in real-time during recording.",
      role: "Podcast Production, Question Crafting, Creative Direction, Conversation Guidance",
      challenge: "Create compelling long-form content that positions Airtribe as an industry thought leader.",
      solution: "Researched guests thoroughly, drafted strategic questions, and actively guided conversations to maintain flow and extract the best content.",
      impact: [
        "Produced 20+ high-quality podcast episodes",
        "Featured prominent industry thought leaders",
        "Strengthened brand authority and audience retention"
      ],
      metrics: [
        { value: "20+", label: "Episodes Produced" },
        { value: "High", label: "Audience Retention" }
      ],
      videoEmbed: "https://www.youtube.com/embed/jyzk702zHRc",
      images: [
        "https://img.youtube.com/vi/jyzk702zHRc/maxresdefault.jpg"
      ],
      tags: ["Podcast", "Content Production", "Thought Leadership", "Creative Direction"]
    },,
        {
      id: 3,
      title: "Ghost Writing and Founder Marketing",
      subtitle: "Building Personal Brands & Thought Leadership",
      description: "Crafted compelling LinkedIn content for Navneet Sharma (Co-founder, Airtribe), establishing his personal brand and strengthening Airtribe's positioning through authentic storytelling and insights.",
      role: "Ghostwriting, Thought Leadership, Personal Branding",
      challenge: "Create authentic founder voice while maintaining consistency with brand messaging and driving engagement.",
      solution: "Developed storytelling-driven posts with insights, personal experiences, and industry perspectives that resonated with the target audience.",
      impact: [
        "Enhanced founder's personal brand significantly",
        "Strengthened Airtribe's brand positioning",
        "Multiple posts with 100K+ impressions"
      ],
      metrics: [
        { value: "100K+", label: "Post Impressions" },
        { value: "High", label: "Engagement" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/r8wa7lio_Screenshot%202026-04-16%20at%2010.34.02%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/ql5bdybi_Screenshot%202026-04-16%20at%2010.32.48%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/zs4d1u01_Screenshot%202026-04-16%20at%2010.34.18%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/ue66np7w_Screenshot%202026-04-16%20at%2010.34.02%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/mg9fjlvb_Screenshot%202026-04-16%20at%2010.33.07%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/z1ytf20a_Screenshot%202026-04-16%20at%2010.34.59%E2%80%AFPM.png"
      ],
      tags: ["Ghostwriting", "LinkedIn", "Thought Leadership", "Personal Branding"]
    },,
        {
      id: 4,
      title: "Developer Marketing at Avail",
      subtitle: "Launching Developer-First Products",
      description: "Led marketing for Avail, a developer-first blockchain infrastructure company. Orchestrated product launches, crafted developer-focused messaging, and built community engagement strategies.",
      role: "Product Launch Marketing, Developer Relations, Community Building",
      challenge: "Market highly technical blockchain products to a developer audience while building trust and credibility.",
      solution: "Developed launch strategies combining technical content, developer community engagement, and clear product messaging.",
      impact: [
        "Successfully launched 3+ major products",
        "Built developer community engagement",
        "Positioned Avail as a thought leader in blockchain"
      ],
      metrics: [
        { value: "3+", label: "Product Launches" },
        { value: "Developer-First", label: "Approach" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/iebnavc9_Screenshot%202026-04-17%20at%202.40.26%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/afcyxc59_Screenshot%202026-04-17%20at%202.40.59%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/7dwf48rq_Screenshot%202026-04-17%20at%202.40.43%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/8513bh8r_Screenshot%202026-04-17%20at%202.39.02%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/e919bgpc_Screenshot%202026-04-17%20at%202.39.16%E2%80%AFPM.png"
      ],
      tags: ["Developer Marketing", "Product Launch", "Blockchain", "Technical Content", "Community"]
    },,
        {
      id: 5,
      title: "Airtribe: YouTube Content That Goes Viral",
      subtitle: "Multiple Videos Hit Viral Status with 83K+ Views",
      description: "Led end-to-end video production for Airtribe's YouTube channel with a lean team of 3 - from scripting and storyboarding to shooting and vision alignment. Created narrative-driven case studies that made complex business topics engaging and shareable.",
      role: "Scriptwriting, Shooting, Storyboarding, Vision Alignment",
      challenge: "Create compelling B2B EdTech content that could compete with high-production channels and go viral.",
      solution: "Developed a lean production process focusing on strong storytelling, strategic scripting, and authentic presentation.",
      impact: [
        "Multiple videos achieved viral status organically",
        "83K+ views on top-performing video",
        "Established Airtribe as thought leader in EdTech"
      ],
      metrics: [
        { value: "83K+", label: "Top Video Views" },
        { value: "Multiple", label: "Viral Videos" }
      ],
      videoEmbed: "https://www.youtube.com/embed/jDy4ixzUJ1E",
      images: [
        "https://img.youtube.com/vi/jDy4ixzUJ1E/maxresdefault.jpg"
      ],
      tags: ["YouTube", "Scriptwriting", "Video Production", "B2B Content", "Viral Content"]
    },,
        {
      id: 6,
      title: "Performance Ads That Drive Revenue",
      subtitle: "Writing, Scripting & Designing Winning Ads",
      description: "Contributed to high-performing ad campaigns at Airtribe through end-to-end creative development - from concept and scriptwriting to storyboarding and final execution. Created both video and graphic ads that resonated with audiences and drove significant conversions.",
      role: "Ad Copywriting, Scriptwriting, Storyboarding, Creative Direction",
      challenge: "Create scroll-stopping ads that not only capture attention but also drive meaningful conversions for Airtribe's programs.",
      solution: "Developed ad concepts that spoke directly to audience pain points, used compelling narratives, and paired strong visuals with persuasive copy to drive action.",
      impact: [
        "Contributed to multiple winning ad campaigns",
        "Ads generated significant revenue for Airtribe",
        "Created repeatable ad frameworks",
        "High conversion rates across video and graphic formats"
      ],
      metrics: [
        { value: "Multiple", label: "Winning Ads" },
        { value: "High ROI", label: "Performance" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/f7vn14wz_Screenshot%202026-04-17%20at%202.21.05%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/wvi85qpd_Screenshot%202026-04-17%20at%202.22.18%E2%80%AFPM.png",
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/ei76m1d1_Screenshot%202026-04-17%20at%202.23.53%E2%80%AFPM.png"
      ],
      tags: ["Performance Ads", "Copywriting", "Creative Direction", "Revenue Generation"]
    },,
        {
      id: 7,
      title: "Airtribe: Instagram Carousels That Educate",
      subtitle: "Visual Learning for Product Managers",
      description: "Designed compelling carousel posts for Airtribe that educated and engaged the community with best practices, frameworks, and insights for Product Managers.",
      role: "Content Strategy, Visual Design, Educational Content",
      challenge: "Transform dense educational content into engaging, swipeable Instagram posts.",
      solution: "Created visually striking carousel designs with clear messaging, using frameworks and best practices from top companies.",
      impact: [
        "Higher swipe-through rates on carousels",
        "Increased saves and shares significantly",
        "Positioned Airtribe as educational authority",
        "Drove community engagement and learning"
      ],
      metrics: [
        { value: "High", label: "Save Rate" },
        { value: "Educational", label: "Value Add" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/k33mztj2_Screenshot%202026-04-17%20at%202.06.50%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/p/DF7v5qpKf1I/",
        "https://www.instagram.com/p/DFej9jzJftD/",
        "https://www.instagram.com/p/DEU2Y1VJ8gF/"
      ],
      tags: ["Instagram Carousels", "Educational Content", "Design", "Product Management"]
    },
        {
      id: 8,
      title: "Revolt Motors: Holi Campaign That Went Viral",
      subtitle: "1.6M+ Views - Weaving Brand Ethos with Festival Spirit",
      description: "Created two Instagram Reels for Revolt Motors' Holi campaign that became the brand's highest-viewed content ever. Blended the vibrant spirit of Holi with Revolt's electric revolution narrative.",
      role: "Content Strategy, Reel Conceptualization, Campaign Execution",
      challenge: "Create festival content that feels authentic while staying true to Revolt's electric vehicle brand identity.",
      solution: "Developed Reels that wove Holi's colorful energy with Revolt's brand ethos of revolution and sustainability, creating content that resonated with both festival emotions and brand values.",
      impact: [
        "1.6M views on primary Holi Reel",
        "1.5M views on secondary Holi Reel",
        "Became Revolt's highest-viewed content",
        "Massively amplified brand reach and visibility"
      ],
      metrics: [
        { value: "1.6M", label: "Views on Reel 1" },
        { value: "1.5M", label: "Views on Reel 2" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/vb2c1tw5_Screenshot%202026-04-17%20at%202.06.21%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/reel/C44h6jkvoe9/",
        "https://www.instagram.com/reel/C42GSUDvmdN/",
        "https://www.instagram.com/reel/C45_-QEvAWK/"
      ],
      tags: ["Instagram Reels", "Campaign Strategy", "Viral Content", "Festival Marketing"]
    },,
        {
      id: 9,
      title: "Stanley Tools: Kaam Chalo Nahi, Daudao",
      subtitle: "1.5 Years of 360° Campaign Success Driving Revenue",
      description: "Created and executed a character-driven 360° campaign that transformed Stanley Tools from 'just another tool brand' to a household name in India. The campaign ran for 1.5 years, integrating social media (organic & paid), collaborations, and brand partnerships to drive consistent positive revenue traction.",
      role: "Campaign Strategy, Content Creation, Social Media (Organic & Paid), Collaboration Management, Inception to Execution",
      challenge: "Stanley Tools needed to stand out in a crowded market, connect with a younger audience, and drive measurable sales impact.",
      solution: "Developed a comprehensive 360° campaign centered around K.C., a relatable character who advocates for safer, simpler, and better solutions. Executed across all channels - social organic, paid ads, influencer collaborations, and brand partnerships - for sustained impact.",
      impact: [
        "Campaign ran successfully for 1.5 years",
        "Enhanced brand awareness and recall significantly",
        "Drove positive revenue traction consistently",
        "12K+ likes on hero content pieces",
        "Positioned Stanley as the go-to for reliability"
      ],
      metrics: [
        { value: "1.5 Years", label: "Campaign Duration" },
        { value: "360°", label: "Omnichannel Reach" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/rwnpz13r_Screenshot%202026-04-17%20at%205.00.20%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/reel/C-kXjJfyrhr/",
        "https://www.instagram.com/p/C6_XH2RhvOz/",
        "https://www.instagram.com/reel/C6yfGETy-_p/",
        "https://www.instagram.com/p/C6GtpHjN0Bs/",
        "https://www.instagram.com/reel/C-uqsggyb4S/"
      ],
      tags: ["Campaign Strategy", "360° Marketing", "Social Media", "Revenue Growth", "Brand Building"]
    },,
        {
      id: 10,
      title: "Un: Sustainable Fashion Meets Social Buzz",
      subtitle: "3,000 Pieces Sold Per Pop-up, 93L Water Saved",
      description: "Promoted sustainable fashion pop-ups using Instagram Stories and Reels, driving massive footfall and revenue while building a community around upcycling. Achieved remarkable sales numbers - 3,000 pieces sold per pop-up - contributing to significant environmental impact with approximately 93 liters of water saved through sustainable clothing choices.",
      role: "Social Media Strategy, Content Creation, Community Building, Sustainability Marketing",
      challenge: "Drive attendance to physical pop-up events in a crowded market while communicating sustainability value.",
      solution: "Created educational and engaging Instagram content that highlighted both the fashion appeal and environmental impact. Leveraged user-generated content and built community buzz that translated to real-world purchases and sustainable choices.",
      impact: [
        "3,000 pieces sold per pop-up event",
        "Approximately 93L of water saved through sustainable fashion",
        "Surge in organic attendance at second pop-up",
        "Built loyal brand community around sustainability"
      ],
      metrics: [
        { value: "3,000", label: "Pieces Sold/Event" },
        { value: "93L", label: "Water Saved" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/bt89zepl_Screenshot%202026-04-17%20at%202.06.02%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/p/C4fqwDJSdzo/",
        "https://www.instagram.com/reel/C4fCjxFL-l6/",
        "https://www.instagram.com/p/C4ufp6xS-5S/",
        "https://www.instagram.com/reel/C5GUWDSyyMQ/",
        "https://www.instagram.com/reel/C5TqmZBS4NB/",
        "https://www.instagram.com/reel/C5as6UYyUoL/",
        "https://www.instagram.com/reel/C5yHW9xJvrv/"
      ],
      tags: ["Instagram Strategy", "Event Marketing", "Sustainability", "Revenue Generation", "UGC"]
    },,
        {
      id: 11,
      title: "Airtribe: Meme Marketing That Actually Works",
      subtitle: "Making B2B Relatable, One Meme at a Time",
      description: "Created humorous, trend-driven meme content for Instagram that made a B2B EdTech brand feel approachable and human.",
      role: "Content Creation, Meme Strategy, Community Engagement",
      challenge: "Make Airtribe's Instagram more engaging and relatable without losing brand authority.",
      solution: "Developed short-form meme videos based on trending topics and industry pain points that resonated with the target audience.",
      impact: [
        "Significant boost in shares and comments",
        "Positioned Airtribe as relatable and engaging",
        "Increased overall Instagram engagement",
        "Built stronger community connection"
      ],
      metrics: [
        { value: "200%+", label: "Engagement Increase" },
        { value: "Viral", label: "Share Rate" }
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_my-work-space-8/artifacts/rnt0q0k7_Screenshot%202026-04-17%20at%202.06.37%E2%80%AFPM.png"
      ],
      instagramLinks: [
        "https://www.instagram.com/reel/DHLndvby1U4/",
        "https://www.instagram.com/reel/DEXbJR7J8YW/",
        "https://www.instagram.com/reel/DDrlqstJVrs/",
        "https://www.instagram.com/reel/DCjge_TT4Ex/",
        "https://www.instagram.com/reel/DBtfZ6Ko8Sw/",
        "https://www.instagram.com/reel/DBeA_pIK7A6/"
      ],
      tags: ["Meme Marketing", "Instagram", "B2B", "Trend Spotting"]
    },
  ],
  
  achievements: [
    {
      metric: "1.6M",
      label: "Impressions",
      description: "Revolt Motors Holi campaign"
    },
    {
      metric: "83K+",
      label: "YouTube Views",
      description: "Breakdown strategy video"
    },
    {
      metric: "50K+",
      label: "Followers Grown",
      description: "organically across platforms"
    },
    {
      metric: "360°",
      label: "Campaigns Led",
      description: "from inception to execution"
    }
  ],
  
  skills: {
    core: ["Content Strategy", "Storytelling", "Meme Marketing", "Community Building"],
    platforms: ["YouTube", "Instagram", "LinkedIn", "Twitter/X"],
    special: ["Trend Spotting", "Scriptwriting", "Growth Hacking", "Performance Analysis"]
  },
  
  tools: [
    "Canva", "Figma", "HubSpot", "SEMRush", "Ahrefs", 
    "Apollo.io", "Google Analytics", "Notion", "Kaito", "ChatGPT"
  ]
};
